import { APP_VERSTION } from "@/constants";

import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import api from "@/services/api";

import "@/styles/app.scss";

import filters from "@/filters";
import plugins from "@/plugins";

import Player from "@/services/player";
import AccessControl from "@/services/AccessControl";
import contextMenu from "@/services/contextMenu";
import errorHandler from "@/services/errorHandler";
import l10n from "@/services/l10n";

import VueClickOutside from "v-click-outside";
import VueEsc from "vue-esc";
import VueDragged from "v-dragged";
import VueShortkey from "vue-shortkey";
import Vuelidate from "vuelidate";

Vue.use(VueShortkey);
Vue.use(VueDragged);
Vue.use(VueClickOutside);
Vue.use(VueEsc);
Vue.use(Vuelidate);
Vue.use(plugins.message);
// Vue.use(plugins.sidebars);
Vue.use(l10n.plugin);
Vue.use(errorHandler.plugin);
Vue.use(contextMenu.plugin);
Vue.use(AccessControl.getPlugin());
Vue.use(Player.getPlugin(), { store });

Vue.filter("duration", time => filters.duration(time));
Vue.filter("date", time => filters.date(time));
Vue.filter("likes", amount => filters.likes(amount));

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: h => h(App),
  async created() {
    store.$app = this;
  },
  async mounted() {
    const authenticated = store.getters["user/authenticated"];
    const token = store.getters["user/token"];

    if (authenticated) {
      api.setAuthorizationHeader(`Bearer ${token}`);

      if (await api.checkAuthorization()) {
        store.dispatch("playlists/fetch");
      } else {
        await store.dispatch("user/logout");
      }
    }
  }
}).$mount("#root");

window.SONG_APP = {
  version: APP_VERSTION,
  author: "dancecolor",
  email: "manager@dancecolor.ru"
};
